<template>
  <div
    :style="{
      ...$store.state.event.goldcastThemeStyles,
      ...$store.state.event.themeStyles
    }"
    :class="recordingMode && 'hidden-component'"
  >
    <template v-if="showing">
      <div :class="['dialog-wrapper', blockBackgroundActions ? 'blockBackgroundActions' : 'accessBackground']">
        <div
          :role="role"
          :class="[
            'dialog-component',
            placement,
            blockBackgroundActions ? 'blockBackgroundActions' : 'accessBackground'
          ]"
        >
          <div v-if="!hideOverlay" role="none" class="bg" @click="tryToClose"></div>
          <component
            :is="component"
            :class="['component', !blockBackgroundActions && 'allowActions']"
            v-bind="props"
            @hide="hide"
            @cancel="cancel"
            @showSuccess="showSuccess"
          />
          <template v-if="successVisible">
            <div class="overlay" />
            <div class="dialog-notify">
              <div class="success-block">
                <span class="success-text">{{ successText }}</span>
                {{ successMessage }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import loggerService from '../logger.service';

export default {
  name: 'dialog-component',
  props: {
    component: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: () => ({})
    },
    hideOverlay: {
      type: Boolean,
      default: false
    },
    cancelOnClickOutside: Boolean,
    autoCancelTimeout: Number,
    placement: {
      type: String,
      default: 'center-center'
    },
    blockBackgroundActions: {
      type: Boolean,
      default: true
    },
    role: {
      type: String,
      default: 'alertdialog'
    }
  },
  data() {
    return {
      showing: true,
      successVisible: false,
      successMessage: '',
      successText: 'SUCCESS !!'
    };
  },
  mounted() {
    if (this.autoCancelTimeout) {
      setTimeout(() => {
        loggerService.warn(`Dialog auto cancelled, timeout of ${this.autoCancelTimeout}ms`);
        this.cancel();
      }, this.autoCancelTimeout);
    }
  },
  computed: {
    recordingMode() {
      return !!this.$route?.query?.record_mode;
    }
  },
  methods: {
    hide(reason) {
      loggerService.info('Dialog hidden', { reason });
      this.waitForAnimation(() => this.$emit('hide', reason));
    },
    cancel(reason) {
      loggerService.info('Dialog cancelled', { reason });
      try {
        this.waitForAnimation(() => this.$emit('cancel', reason));
      } catch (e) {
        loggerService.warn(e ?? 'Error Caught');
      }
    },
    showSuccess(successText, successMessage) {
      this.successMessage = successMessage;
      this.successText = successText;
      this.successVisible = true;
      setTimeout(() => {
        this.successVisible = false;
        this.cancel('');
      }, 1500);
    },
    waitForAnimation(cb) {
      this.showing = false;
      setTimeout(cb, 350);
    },
    tryToClose() {
      if (this.cancelOnClickOutside) {
        this.cancel();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.hidden-component {
  display: none;
}
.dialog-wrapper {
  --fixed-margin-x: 16px;
  --fixed-margin-y: 16px;
  --sidebar-width: 390px;

  .edge {
    --fixed-margin-x: 0px;
    --fixed-margin-y: 0px;
  }
  .bottom-right {
    right: var(--fixed-margin-x);
    bottom: var(--fixed-margin-y);
  }
  .bottom-left {
    left: var(--fixed-margin-x);
    bottom: var(--fixed-margin-y);
  }
  .top-left {
    left: var(--fixed-margin-x);
    top: var(--fixed-margin-y);
  }
  .top-right {
    right: var(--fixed-margin-x);
    top: var(--fixed-margin-y);
  }
  .center-center {
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
  }
  .stage-center {
    width: calc(100vw - var(--sidebar-width));
    height: 100vh;
    left: 0;
    top: 0;
  }
  .dialog-component {
    position: fixed;
    z-index: 55;
    opacity: 1;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .blockBackgroundActions {
    pointer-events: all;
  }

  & .accessBackground {
    pointer-events: none;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
}

.fade-enter,
.fade-leave-to {
  transform: scale(0);
  opacity: 0;
}

.bg {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  background: rgba(0, 0, 0, 0.4);
}
.component.allowActions {
  pointer-events: all;
}

.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  background: black;
  opacity: 50%;
  bottom: 0;
  border-radius: 20px;
  z-index: 27;
}

.dialog-notify {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  border-radius: 20px;
}

.success-block {
  position: fixed;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  font-size: 14px;
  top: 40%;
  width: auto;
  animation: notify ease 0.5s;
  -webkit-animation: notify ease 0.5s;
  -moz-animation: notify ease 0.5s;
  -o-animation: notify ease 0.5s;
  z-index: 12;
  /* box-shadow: 0 4px 5px 0 #eff3f3; */
}

.success-text {
  font-size: 20px;
  color: #2ebd59;
  font-weight: 600;
  margin: 0 0 10px 0;
}

@keyframes notify {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-moz-keyframes notify {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-webkit-keyframes notify {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-o-keyframes notify {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

@-ms-keyframes notify {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@media only screen and (max-width: 600px) {
  .dialog-wrapper {
    --sidebar-width: 0px;
  }
}
</style>
